export default __webpack_public_path__ + "files/userImportSample.3166cd70.xls";